/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

import {register} from '@shopify/theme-sections';

register('collection-navbar', {
  onLoad() {
    // If collection URL has a sort parameter, set sort dropdown to matching value
    const currentUrl = new URL(window.location);
    const sortByParam = currentUrl.searchParams.get('sort_by');
    if (sortByParam) {
      document.querySelector('#sort-by').value = sortByParam;
    } else {
      document.querySelector('#sort-by').value = 'manual';
    }

    // Handle sort by selection change
    document.querySelector('#sort-by').addEventListener('change', function () {
      // Reload the page with the selected sort parameter applied. If 'manual' sort order
      // is selected, remove the sort_by parameter.
      const newUrl = new URL(window.location);
      if (event.target.value === 'manual') {
        newUrl.searchParams.delete('sort_by');
      } else {
        newUrl.searchParams.set('sort_by', event.target.value);
      }
      window.location = newUrl;
    });

    // Layout switcher
    const layoutSwitchDefaultButton = document.querySelector('.layout-switch--default');
    const layoutSwitchAltButton = document.querySelector('.layout-switch--alt');
    const collectionGrid = document.querySelector('.collection-grid');

    if (layoutSwitchDefaultButton) {
      layoutSwitchDefaultButton.addEventListener('click', function () {
        collectionGrid.classList.add('collection-grid--default');
        collectionGrid.classList.remove('collection-grid--alt');
        layoutSwitchDefaultButton.setAttribute('disabled', 'disabled');
        layoutSwitchDefaultButton.setAttribute('aria-pressed', 'true');
        layoutSwitchDefaultButton.classList.add('is-selected');
        layoutSwitchAltButton.setAttribute('aria-pressed', 'false');
        layoutSwitchAltButton.removeAttribute('disabled');
        layoutSwitchAltButton.classList.remove('is-selected');
      });
      layoutSwitchAltButton.addEventListener('click', function () {
        collectionGrid.classList.add('collection-grid--alt');
        collectionGrid.classList.remove('collection-grid--default');
        layoutSwitchAltButton.setAttribute('disabled', 'disabled');
        layoutSwitchAltButton.setAttribute('aria-pressed', 'true');
        layoutSwitchAltButton.classList.add('is-selected');
        layoutSwitchDefaultButton.setAttribute('aria-pressed', 'false');
        layoutSwitchDefaultButton.removeAttribute('disabled');
        layoutSwitchDefaultButton.classList.remove('is-selected');
      });
    }

    // Navigation (Filter)
    const filterTrigger = document.querySelector('[data-trigger-filter-accordion]');
    const filterDialogue = document.querySelector('#CollectionNavDialogue');

    if (filterTrigger && filterDialogue) {
      filterTrigger.addEventListener('click', function () {
        if (filterTrigger.dataset.triggerFilterAccordion === 'false') {
          filterTrigger.dataset.triggerFilterAccordion = true;
          filterDialogue.setAttribute('aria-expanded', 'true');
        } else {
          filterTrigger.dataset.triggerFilterAccordion = false;
          filterDialogue.setAttribute('aria-expanded', 'false');
        }
      });
    }
  },
});
